import { create } from "zustand";

interface ConciergePendingQueryState {
  pendingQuery: string | null;
  pendingStacklineSku: string | null;
  // Unique ID to track each query and prevent duplicate processing
  pendingQueryId: string | null;
  setPendingQuery: (query: string, stacklineSku: string | null) => void;
  clearPendingQuery: () => void;
}

export const useConciergePendingQuery = create<ConciergePendingQueryState>(
  (set) => ({
    pendingQuery: null,
    pendingStacklineSku: null,
    pendingQueryId: null,
    setPendingQuery: (query: string, stacklineSku: string | null) =>
      set({
        pendingQuery: query,
        pendingStacklineSku: stacklineSku,
        // Generate a unique ID for this query request
        pendingQueryId: `${Date.now()}-${Math.random().toString(36).slice(2)}`,
      }),
    clearPendingQuery: () =>
      set({ pendingQuery: null, pendingStacklineSku: null, pendingQueryId: null }),
  })
);

